import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

/**
 * @typedef {{
 *   ui: {
 *     dashboard: {
 *       data: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 *       filters: import('./ui/filters').PaymentsFiltersReducer,
 *       amount: {
 *          loading: boolean,
 *          total: number,
 *       }
 *     }
 *   },
 *   data: import('./data.js').PaymentDataEntity
 * }} PaymentReducer
 */

export default combineReducers({
  data,
  ui,
});
